export default __webpack_public_path__ + "static/media/ErrorImage.27b74f5e.png";